import React, { Component } from "react";
import { Input, Select, Checkbox, Button } from "antd";
import _ from "lodash";
import { langCheck } from "Pub/js/utils";
import { getMulti } from 'Pub/js/getMulti';
import platform from "Pub/js/platform";
const { NCCheckbox, NCSelect, NCMultiLangText } = platform.base;
const Option = NCSelect.NCOption;
const Search = Input.Search;
//批量设置的组件单元类
// 多语文本类
export class MultiLangCell extends React.Component {
    constructor(props) {
        super(props);
    }
    //控制渲染
    shouldComponentUpdate(nextProps, nextState) {
        const thisProps = this.props || {},
            thisState = this.state || {};
        if (this.props.value !== nextProps.value) {
            return true;
        }
        return false;
    }
    changeMultiLangText(value, propertyKey) {
        console.log(value, propertyKey)
        let itemValue = Object.fromEntries(
            Object.entries(value).map(el => [el[0], el[1].value])
        )
        this.props.updateValue(itemValue);
    }
    render() {
        const { value, property, multiOptions } = this.props;
        return (
            <NCMultiLangText
                style={{ width: 100 }}
                value={value}
                onChange={value => {
                    this.changeMultiLangText(value, property);
                }}
                onBlur={value => {
                    this.changeMultiLangText(value, property);
                }}
                ref={input => (this[`${property}input`] = input)}
                disabled={false}
                fieldid={property}
                languageMeta={multiOptions}
                attrcode={property}
            />
        )
    }
}
//输入框组件类
export class EditableCell extends React.Component {
    constructor(props) {
        super(props);
    }
    //数据变化
    handleChange = e => {
        const value = e.target.value;
        this.props.updateValue(value);
    };
    //控制渲染
    shouldComponentUpdate(nextProps, nextState) {
        const thisProps = this.props || {},
            thisState = this.state || {};
        if (this.props.value !== nextProps.value) {
            return true;
        }
        return false;
    }
    render() {
        const { value, property } = this.props;
        return (
            <Input
                size="small"
                style={{ width: 100 }}
                value={value}
                onChange={this.handleChange}
                ref={input => (this[`input`] = input)}
            />
        );
    }
}
//编辑一纵列单元格组件类
export class EditAllCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: "",
            json: {}
        };
    }
    //点击确定
    handleClick = e => {
        this.props.onChange(this.state.inputValue);
        this.props.hidePopover();
    };
    //隐藏popOver输入框
    close = () => {
        this.props.hidePopover();
    };
    //数据变化
    changeValue = e => {
        this.setState({ inputValue: e.target.value });
    };
    componentDidMount() {
        //多语
        let callback = (json) => {
            // console.log('json', json);
            this.setState({
                json: json
            });
        };
        getMulti({
            moduleId: 'ZoneSetting',
            // currentLocale: 'zh-CN',
            domainName: 'workbench',
            callback
        });
    }
    render() {
        let { json } = this.state;
        return (
            <div className="custom-filter-dropdown">
                <Input
                    value={this.state.inputValue}
                    size="small"
                    ref={`customInput`}
                    onChange={this.changeValue}
                />
                <Button type="primary" onClick={this.handleClick}>
                    {langCheck('ZoneSetting-000005', 'pages', json)}
                    {/* /* 国际化处理： 确定*/}
                </Button>
                <Button onClick={this.close}>{langCheck('ZoneSetting-000006', 'pages', json)}</Button>
                {/* /* 国际化处理： 取消*/}
            </div>
        );
    }
}
//复选框组件类
export class EditableCheck extends React.Component {
    constructor(props) {
        super(props);
    }
    //checked选择值变化
    handleChange = val => {
        this.props.onChange(val);
    };
    //控制渲染
    shouldComponentUpdate(nextProps, nextState) {
        const thisProps = this.props || {},
            thisState = this.state || {};
        if (this.props.value !== nextProps.value) {
            return true;
        }
        return false;
    }
    render() {
        const { value } = this.props;
        return (
            <NCCheckbox checked={Boolean(value)} onChange={this.handleChange} />
        );
    }
}
//选择框组件类
export class SelectCell extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.tableScrollContainer = document.querySelector('.batch-setting-table').querySelector('.base-table-body-scroll-wrapper');
        this.tableScrollContainer.addEventListener('scroll', this.handleTableScroll);
    }
    componentWillUnmount() {
        this.tableScrollContainer.removeEventListener('scroll', this.handleTableScroll);
    }
    handleTableScroll = () => {
        this.selectRef.select.querySelector('input').blur();
    }
    //下拉选择变化
    handleSelectChange = value => {
        this.props.onChange(value);
    };
    //控制渲染
    shouldComponentUpdate(nextProps, nextState) {
        const thisProps = this.props || {},
            thisState = this.state || {};
        if (this.props.selectValue !== nextProps.selectValue) {
            return true;
        }
        return false;
    }
    render() {
        const { selectValue, selectObj, property } = this.props;
        return (
            <NCSelect
                ref={ref => this.selectRef = ref}
                showClear={false}
                value={
                    _.isEmpty(selectValue) ? selectObj[0].value : selectValue
                }
                onChange={value => {
                    this.handleSelectChange(value);
                }}
                // style={{ width: 100 }}
                size={"small"}
                fieldid={property}
            >
                {(() => {
                    if (property === "color") {
                        return selectObj.map((c, index) => {
                            return (
                                <Option key={index} value={c.value}>
                                    <span className="template-setting-color-select">
                                        <span>{c.name}</span>
                                        <span
                                            className="color-select-color"
                                            style={{ backgroundColor: c.value }}
                                        />
                                    </span>
                                </Option>
                            );
                        });
                    } else {
                        return selectObj.map((c, index) => {
                            return (
                                <Option key={index} value={c.value}>
                                    {c.name}
                                </Option>
                            );
                        });
                    }
                })()}
            </NCSelect>
        );
    }
}

//公式组件类
export class FormulaCell extends React.Component {
    constructor(props) {
        super(props);
    }
    //数据变化
    handleChange = e => {
        const value = e.target.value;
        this.props.updateValue(value);
    };
    //控制渲染
    shouldComponentUpdate(nextProps, nextState) {
        const thisProps = this.props || {},
            thisState = this.state || {};
        if (this.props.value !== nextProps.value) {
            // 这里调用一下 保证 batchTable 可以调用 onCellChange
            // 保证 batchSettingModal可以争取记录  当前页签是否变化
            // 让弹窗关闭时待更新目标页签争取，值可以争取更新到  非弹窗下的高级属性里
            // 后续如果出现了更新循环或者性能问题
            this.props.updateValue(nextProps.value);
            return true;
        }
        return false;
    }
    render() {
        const { value, onFormula } = this.props;
        return (
            <Search
                size="small"
                style={{ width: 100 }}
                value={value}
                onChange={() => { }}
                onSearch={onFormula}
            />
        );
    }
}
